import get from 'lodash/get'
import { cloneDeep } from 'lodash'
import { getField, updateField } from 'vuex-map-fields'
import { ToastProgrammatic as Toast } from 'buefy'
import Membership from '../models/memberships/membership.js'

const getDefaultState = () => {
  return {
    isSubmitting: false,
    lastApproved: null,
    addressData: getDefaultAddressDataState()
  }
}

function getDefaultAddressDataState() {
  return {
    country: null,
    addressLine1: null,
    addressLine2: null,
    streetNumber: null,
    zipCode: null,
    city: null,
    county: null,
    state: null
  }
}

export const state = () => getDefaultState()

export const getters = {
  getField,
  isSubmitting(state) {
    return state.isSubmitting
  },
  lastApproved(state) {
    if (state.lastApproved && JSON.stringify(state.lastApproved) !== '{}') {
      return Membership.create(cloneDeep(state.lastApproved))
    } else {
      return state.lastApproved
    }
  }
}

export const mutations = {
  updateField,
  isSubmitting(state, isSubmitting) {
    state.isSubmitting = isSubmitting
  },
  lastApproved(state, lastApproved) {
    state.lastApproved = lastApproved
  },
  updateAddress(state, address) {
    state.lastApproved.address = address
  }
}

export const actions = {
  async getLastApproved({ commit }) {
    const id = this.$auth.user.athlete?.lastApprovedMembershipId

    const result = await this.$coreApi.$get(`athletes/memberships/${id}`)

    commit('lastApproved', result.data)
  },
  async submitAddress({ commit, dispatch, state }) {
    dispatch('isSubmitting', true)

    const id = this.$auth.user.athlete?.lastApprovedMembershipId

    try {
      await this.$coreApi.$post(`athletes/memberships/${id}/submit_address_correction`, {
        address: get(state, ['addressData'])
      })

      Toast.open({
        duration: 7000,
        message: this.$i18n.t('pages.membershipCorrections.addressChangeSuccessMessage'),
        position: 'is-bottom',
        type: 'is-success'
      })

      this.$router.push(this.app.localePath({ name: 'dashboard' }))
    } catch (e) {
      const errors = get(e, 'response.data.message')

      if (errors) {
        dispatch('notifyErrors', errors)
      } else {
        Toast.open({
          duration: 4000,
          message: this.$i18n.t('pages.membershipCorrections.addressChangeErrorMessage'),
          position: 'is-top',
          type: 'is-danger'
        })

        throw e
      }
    } finally {
      Object.assign(state, getDefaultState())
      await this.$auth.fetchUser()
      dispatch('isSubmitting', false)
    }
  },
  resetAddress({ commit, state }) {
    commit('updateField', { path: 'addressData', value: getDefaultAddressDataState() })
  },
  notifyErrors({ commit }, errors) {
    errors.forEach(err => {
      Toast.open({
        duration: 4000,
        message: err.property + ': ' + Object.values(err.constraints),
        position: 'is-top',
        type: 'is-danger'
      })
    })
  },
  isSubmitting({ commit }, isSubmitting) {
    commit('isSubmitting', isSubmitting)
  }
}
